import { gt } from 'ramda';

export const tagAccessor = (count, total) => (gt(count, 0) ? count : null);
